import { queryFirst, queryAll, addClass, removeClass } from '../../domUtil';
import { geolocate } from '../../util';

const hiddenClass = 'd-none';

/**
 * This method toggles the location icon state in pick up in store drawer
 * @param {boolean} isGeolocationAllowed -geo location permission
 * @param {HTMLElement} container - ISPU container
 */
function toggleLocationIcon(isGeolocationAllowed, container) {
    const locationInactiveIcon = queryFirst('.geolocation-not-activated', container);
    const locationActiveIcon = queryFirst('.geolocation-activated', container);
    if (isGeolocationAllowed) {
        removeClass(locationActiveIcon, hiddenClass);
        addClass(locationInactiveIcon, hiddenClass);
    } else {
        removeClass(locationInactiveIcon, hiddenClass);
        addClass(locationActiveIcon, hiddenClass);
    }
}

/**
 * This method handles event on clicking 'use my location' link
 * @param {Event} event - on click event object
 * @param {HTMLElement} ispuContainer - ISPU container
 * @param {Function} handleInStore - Success callback handler
 */
function handleDetectLocation(event, ispuContainer, handleInStore) {
    const { target } = event;
    const { actionUrl } = target.dataset;
    const mixinData = { actionUrl, forceGeoLocation: true };
    const noStoresMessage = queryFirst('.store-locator-no-results', ispuContainer);
    const storeResults = queryFirst('.pick-up-in-stores', ispuContainer);
    queryFirst('.find-store-input', ispuContainer).value = '';
    queryFirst('.find-store-submit', ispuContainer).disabled = true;
    geolocate(handleInStore, mixinData, () => {
        removeClass(queryFirst('.geo-location-error', ispuContainer), hiddenClass);
        addClass([storeResults, noStoresMessage], hiddenClass);
    });
}

/**
 * This method cleans up the state on closing ISPU modal
 * @param {HTMLElement} ispuContainer - ISPU container
 */
function handleISPUModalClose(ispuContainer) {
    queryFirst('.find-store-input', ispuContainer).value = '';
    removeClass(queryAll('.pickup-in-store-product, .find-stores-form', ispuContainer), hiddenClass);
    queryFirst('.pick-up-in-stores', ispuContainer).innerHTML = '';
    const noStoresMessage = queryFirst('.store-locator-no-results', ispuContainer);
    const confirmSection = queryFirst('.pick-up-confirm-section', ispuContainer);
    const geolocateError = queryFirst('.geo-location-error', ispuContainer);
    confirmSection.innerHTML = '';
    addClass([confirmSection, noStoresMessage, geolocateError], hiddenClass);
    queryFirst('.find-store-submit', ispuContainer).disabled = true;
}

export {
    handleISPUModalClose,
    handleDetectLocation,
    toggleLocationIcon
};
